import React from 'react'
import PropTypes from 'prop-types'
import './Step.scss'

export default class Step extends React.Component {
  static propTypes = {
    isCollapsed: PropTypes.bool,
    status: PropTypes.oneOf(['unverified', 'verified', 'incomplete', 'complete']),
    title: PropTypes.string,
    children: PropTypes.element,
  }

  static defaultProps = {
    isCollapsed: false,
    isLoading: false,
    status: 'unverified',
  }

  getStepClasses = () => {
    const { status } = this.state
    const { isCollapsed } = this.props
    if (isCollapsed) {
      return 'step alert alert-success'
    }
    switch (status) {
      case 'unverified':
      case 'verified':
        return 'step alert alert-primary'
      case 'incomplete':
        return 'step alert alert-danger'
      case 'complete':
        return 'step alert alert-success'
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      status: 'unverified'
    }
  }

  render () {
    const { title, isCollapsed } = this.props
    return (
      <div className={this.getStepClasses()}>
        <h4 className={isCollapsed ? 'inline' : ''}>{ title }</h4>
        <div className={isCollapsed ? 'inline right' : ''}>
          {this.props.children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Step.js